var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-wrapper"},[_c('table',{staticClass:"box",attrs:{"cellspacing":"0"}},[(_vm.loading)?_c('Spin',{attrs:{"fix":"","size":"large"}}):_vm._e(),_vm._v(" "),_c('thead',[_vm._t("thead")],2),_vm._v(" "),_c('tbody',[_vm._t("tbody")],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f2ad3ff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/Table.vue
// module id = null
// module chunks = 